import React from 'react';
import Heading from './Heading';
import { Helmet } from 'react-helmet';


const ConsultantCare = ({ title }) => {
    const isBusinessSolution = title === "Consultant Care";

    const isconsultant = title === "Consultant Care";

    return (
        <div className="w-full max-w-[1320px] px-4 mx-auto mt-4">
            <Helmet>
                <title>Consultant Care | Nexify Infosystems</title>
                <meta name="description" content="Join Nexify's Consultant Care program and get access to support, benefits, career coaching, and a community dedicated to your success." />
                <meta name="keywords" content="Consultant Care, Career Coaching, Nexify, Consultant Support, Consultant Benefits, Career Development, Alumni Program" />
            </Helmet>
            <Heading
                maintitle="Careers"
                title={
                    <>
                        <span>Consultant </span>
                        <span className={isBusinessSolution ? "text-red-500" : "text-black"}> Care</span>
                    </>
                }
            />

            <div className="bg-white flex  md:flex-row p-6 w-full max-w-[1320px] gap-10 mt-2">
                <div className="flex-1">
                    <p className="text-gray-600 mb-4 text-sm " style={{ lineHeight: '2' }}>
                        Our focus is to support you on your career path with exceptional opportunities across the country and all major industries. Once you've joined the Nexify Family, our top priority is to ensure your success by providing continued engagement and support.
                    </p>
                    <h2 className='text-xl text-gray-900 font-[500]'>Consultant Relationship Coordinators</h2>
                    <p className="text-gray-600 text-sm " style={{ lineHeight: '2' }}>Our local Consultant Relationship Coordinators in each major branch ensure you have access to the resources and information required for a positive experience. Their goals include the following:</p>
                    <ul className='text-gray-600 text-sm list-disc ml-10' style={{ lineHeight: '2' }}>
                        <li> Maintaining open lines of communication with you </li>
                        <li> Ensuring your satisfaction with Nexify and the end client </li>
                        <li> Communicating details about programs and other available offerings </li>
                        <li>Reminding you about benefits enrollment deadlines </li>
                        <li>Serving as an escalation point </li>
                        <li>Answering questions and resolving concerns </li>
                        <li> Acting as a sounding board for feedback and suggestions </li>

                    </ul>
                    <p className="text-gray-600 text-sm " style={{ lineHeight: '2' }}>
                        Once enrolled, you'll have access to your benefits information 24/7 via BenefitSolver.
                    </p>

                </div>
            </div>
            <div className="bg-white flex  md:flex-row p-6 w-full max-w-[1320px] gap-10 lg:mt-[-35px]">
                <div className="flex-1">
                    <h2 className='text-xl text-gray-900 font-[500]'>Consultant Care Center</h2>
                    <p className="text-gray-600 text-sm " style={{ lineHeight: '2' }}>Our national Consultant Care team is available to assist you with questions and concerns. Similar to the local Consultant Care Coordinators, this team is here to help with questions regarding the following: </p>
                    <ul className='text-gray-600 text-sm list-disc ml-10' style={{ lineHeight: '2' }}>
                        <li> Benefits and 401(K)</li>
                        <li> MyNexify Time Management System</li>
                        <li>MyNexify Consultant Portal</li>
                        <li>Training and development</li>
                        <li>Updating personal information</li>
                        <li>General information</li>
                    </ul>
                </div>
            </div>
            <div className="bg-white flex  md:flex-row p-6 w-full max-w-[1320px] gap-10 lg:mt-[-35px]">
                <div className="flex-1">
                    <h2 className='text-xl text-gray-900 font-[500]'>Building a Long-Term Relationship</h2>
                    <p className="text-gray-600 text-sm " style={{ lineHeight: '2' }}>To help you succeed, all levels of the Nexify Family, including your account manager is focused on creating an environment for growth, recognition, individual development, and a long-term partnership. Upon joining, you can expect continued engagement and support.</p>
                    <ul className='text-gray-600 text-sm list-disc ml-10' style={{ lineHeight: '2' }}>
                        <li> Facilitated and guided onboarding experience </li>
                        <li>  Relationship building and team building activities </li>
                        <li>  Goal setting and developing a progression path </li>
                        <li>  Frequent communication and scheduled check-ins start to finish, ensuring you meet your goals </li>
                        <li>  Timely responsiveness to your requests </li>
                        <li>  Continued and honest feedback on your performance </li>
                        <li>  Visible recognition </li>
                    </ul>
                </div>
            </div>
            <div className="bg-white flex  md:flex-row p-6 w-full max-w-[1320px] gap-10 lg:mt-[-35px] ">
                <div className="flex-1">
                    <h2 className='text-xl text-gray-900 font-[500] mb-5'>Consultant Community</h2>
                    <p className="text-gray-600 text-sm " style={{ lineHeight: '2' }}>As part of our commitment to providing you with a positive experience, we maintain an open communication approach and outreach programs via social media, articles, and newsletters for community engagement. </p>
                    <ul className='text-gray-600 text-sm list-disc ml-10' style={{ lineHeight: '2' }}>
                        <li> Staying connected via Instagram, Twitter, Facebook LinkedIn and other social media platforms</li>
                        <li> Articles to help you stay informed and learn about career tips and training</li>
                        <li> Committed to making the communities in which you live and work better by publicly announcing and promoting our philanthropy efforts via social media </li>
                    </ul>
                    <p className="text-gray-600 text-sm " style={{ lineHeight: '2' }}>Check out our Grants for Good Program.
                        <br />
                        We also developed and implemented the Nexify Alumni and Transition Coaching Programs to support you post assignment.
                    </p>
                </div>
            </div>
            <div className="bg-white flex  md:flex-row p-6 w-full max-w-[1320px] gap-10 lg:mt-[-35px]">
                <div className="flex-1">
                    <h2 className='text-xl text-gray-900 font-[500]'>Transition Coaching Program</h2>
                    <p className="text-gray-600 text-sm " style={{ lineHeight: '2' }}>You will continue to receive quality services, post assignment and have the opportunity to partake in our Transition Coaching Program. Transition coaching helps you prepare for your next assignment and is a component of our talent engagement and career services workshops delivered live once a quarter.</p>
                    <ul className='text-gray-600 text-sm list-disc ml-10' style={{ lineHeight: '2' }}>
                        <li> Career changes advise</li>
                        <li>Networking tips</li>
                        <li>LinkedIn profile tips</li>
                        <li> Writing resumes and cover letters</li>
                        <li>Job search strategy and resources</li>
                        <li>Coaching on interview best practices</li>
                        <li>Advice for effectively working with recruiters</li>
                        <li>Skills development post-assignment to receive additional training and skill development via ATU</li>
                    </ul>
                </div>
            </div>
            <div className="bg-white flex  md:flex-row p-6 w-full max-w-[1320px] gap-10 mb-4 lg:mt-[-35px]">
                <div className="flex-1">
                    <h2 className='text-xl text-gray-900 font-[500]'>Alumni Program</h2>
                    <p className="text-gray-600 text-sm " style={{ lineHeight: '2' }}>As a peak performer and post assignment, you can join our Alumni Program. To remain engaged, we also encourage you to join our Talent Network to receive jobs notifications based on your skill set and preference. </p>
                    <ul className='text-gray-600 text-sm list-disc ml-10' style={{ lineHeight: '2' }}>
                     <li> Transition Coach and Contract Replacement Advocate</li>
                     <li>  Career Trends Coaching</li>
                     <li> Customized Skills Development Plan </li>
                     <li>  Engagement and Communication Platforms</li>
                     <li> Nexify Career Readiness Site</li>
                     <li> Talent Network, our job portal with alert notifications and thousands of job postings</li>
                     <li>  Social Media Engagement: Instagram, Twitter, Facebook, LinkedIn Platforms</li>
                     <li> Monthly Alumni Newsletter</li>
                     <li>  Articles and workshops</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ConsultantCare;
